import React from 'react';
import useStore from '../store/useStore';

function ModalForm({ isOpen, closeModal, handleSubmit, loading }) {
  //-----------------
  const name = useStore((state) => state.name);
  const email = useStore((state) => state.email);
  const phone = useStore((state) => state.phone);
  const companyName = useStore((state) => state.companyName);

  const projectName = useStore((state) => state.projectName);

  const budget = useStore((state) => state.budget);
  const bid = useStore((state) => state.bid);
  const projectApplication = useStore((state) => state.projectApplication);
  const estimateInstallDate = useStore((state) => state.estimateInstallDate);
  const mount = useStore((state) => state.mount);
  const onsiteCommissioningRequired = useStore((state) => state.onsiteCommissioningRequired);
  const warrantyRequirement = useStore((state) => state.warrantyRequirement);
  const inputResolution = useStore((state) => state.inputResolution);
  const quantityOfInputs = useStore((state) => state.quantityOfInputs);
  const trimRequired = useStore((state) => state.trimRequired);
  //-----------------
  const setname = useStore((state) => state.setname);
  const setemail = useStore((state) => state.setemail);
  const setphone = useStore((state) => state.setphone);
  const setcompanyname = useStore((state) => state.setcompanyname);

  const setProjectName = useStore((state) => state.setProjectName);

  const setBudget = useStore((state) => state.setBudget);
  const setBid = useStore((state) => state.setBid);
  const setProjectApplication = useStore((state) => state.setProjectApplication);
  const setEstimateInstallDate = useStore((state) => state.setEstimateInstallDate);
  const setMount = useStore((state) => state.setMount);
  const setOnsiteCommissioningRequired = useStore((state) => state.setOnsiteCommissioningRequired);
  const setWarrantyRequirement = useStore((state) => state.setWarrantyRequirement);
  const setInputResolution = useStore((state) => state.setInputResolution);
  const setQuantityOfInputs = useStore((state) => state.setQuantityOfInputs);
  const setTrimRequired = useStore((state) => state.setTrimRequired);


  if (!isOpen) return null;

  return (
    <div className="modal-frame">
      <div className="modal-content-frame">
        <form onSubmit={(e) => handleSubmit(e)}>
                <h5>Please fill out this form and click submit button. The PDF file will be automatically downloaded to your device. Contact HD Distuibuting for any questions +1-877-307-6689.</h5>
                      <div className="row mt-4">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                            <div htmlFor="name">Name<span className="required-marker">*</span></div>
                            <input onChange={(e) => setname(e.target.value)} placeholder="Enter your name" value={name} required />  
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                            <div htmlFor="email">Email<span className="required-marker">*</span></div>
                            <input onChange={(e) => setemail(e.target.value)} type="email" placeholder="Enter your email" value={email} required />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                            <div htmlFor="name">Phone Number<span className="required-marker">*</span></div>
                            <input onChange={(e) => setphone(e.target.value)} type="tel" pattern="[0-9]{3}[0-9]{3}[0-9]{4}" placeholder="8881234567" value={phone} required />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                              <div htmlFor="projectname">Project Name<span className="required-marker">*</span></div>
                              <input onChange={(e) => setProjectName(e.target.value)} placeholder="Your project name" type="text" value={projectName} required />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                            <div htmlFor="name">Company/Partner Name <span className="required-marker">*</span></div>
                            <input onChange={(e) => setcompanyname(e.target.value)} value={companyName} required />
                          </div>
                        </div>
                        <div className="col">
                        </div>
                      </div>
                      <div className="row">
                       <h5>Project Details</h5>
                       <hr></hr>
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                              <div htmlFor="budget">Budget(USD)</div>
                              <input onChange={(e) => setBudget(e.target.value)} type="number" value={budget} />
                          </div>
                          <div className="form_group">
                              <div htmlFor="bid">Bid</div>
                              <select id="bid" onChange={(e) => setBid(e.target.value)} className="form-select" value={bid}>
                                <option value="-">-</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                          </div>
                          <div className="form_group">
                              <div htmlFor="projectapplication">Project Application</div>
                                <input onChange={(e) => setProjectApplication(e.target.value)} value={projectApplication}/>
                          </div>
                          <div className="form_group">
                              <div htmlFor="estmateinstallDate">Estimate Installation Date</div>
                              <input type="date" onChange={(e) => setEstimateInstallDate(e.target.value)} value={estimateInstallDate}/>
                          </div>
                          <div className="form_group">
                              <div htmlFor="mount">Mount</div>
                              <select className="form-select" onChange={(e) => setMount(e.target.value)} value={mount}>
                                <option value="-">-</option>
                                <option value="Wall Mount">Wall Mount</option>
                                <option value="Hanging">Hanging</option>
                              </select>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="form_group">
                              <div htmlFor="onsitecommissioningrequired">Onsite Commissioning Required</div>
                              <select className="form-select" onChange={(e) => setOnsiteCommissioningRequired(e.target.value)} value={onsiteCommissioningRequired}>
                                <option value="-">-</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                          </div>
                          <div className="form_group">
                              <div htmlFor="warrantyrequirement">Warranty Requirement</div>
                              <select className="form-select" onChange={(e) => setWarrantyRequirement(e.target.value)} value={warrantyRequirement}>
                                <option value="-">-</option>
                                <option value="2 Years (Standard)">2 Years (Standard)</option>
                                <option value="3 Years">3 Years</option>
                                <option value="5 Years">5 Years</option>
                              </select>
                          </div>
                          <div className="form_group">
                              <div htmlFor="inputresolution">Input Resolution</div>
                              <select className="form-select" onChange={(e) => setInputResolution(e.target.value)} value={inputResolution}>
                                <option value="-">-</option>
                                <option value="Full HD Only">Full HD Only</option>
                                <option value="4K">4K</option>
                              </select>
                          </div>
                          <div className="form_group">
                              <div htmlFor="quantityofinputs">Quantity of Inputs</div>
                              <input type="number" onChange={(e) => setQuantityOfInputs(e.target.value)} value={quantityOfInputs}/>
                          </div>
                          <div className="form_group">
                              <div htmlFor="trimrequired">Trim Required</div>
                              <select className="form-select" onChange={(e) => setTrimRequired(e.target.value)} value={trimRequired}>
                                <option value="-">-</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                          </div>
                        </div>
                      </div>
                      <button className="btn mt-3" id="btn-form" type="submit" disabled={loading}>{loading ? 'Submitting...' : 'Submit'}</button>
                      <button className="btn mt-3" id="btn-form" onClick={closeModal}>Cancel</button>

        </form>
      </div>
    </div>
  );
}


export default ModalForm;
